const theme = {
    colors: {
      primary: '#1D1F48',
    },
  };
  export default theme;